<template>
  <div>
    <div class="uk-position-top-right" style="margin: 2rem">
      <a :uk-tooltip="`title: ${$t('home.languages')} ; pos: left ;offset:0`" class="header-widget-icon">
        <img :src="languageFlag || getLanguageFlag" alt="" class="rounded-sm" height="36" width="36"/>
      </a>
      <!-- Language dropdown -->
      <div ref="languageRefs" class="dropdown-notifications dropdown-languages"
           uk-dropdown=" pos: top-right;mode:click">
        <!-- notification contents -->
        <div class="dropdown-notifications-content" data-simplebar>
          <!-- notiviation list -->
          <ul style="background-color: white">
            <template v-for="(item, i) in languages">
              <li v-if="item.lang !== activeLanguage" :key="i" :class="{
                'navi-item-active': isActiveLanguage(item.lang),
              }" class="navi-item">
                <a class="navi-link" href="#" v-bind:data-lang="item.lang" v-on:click="selectedLanguage">
                  <span class="symbol symbol-20 mr-3">
                    <img :src="item.flag" alt="" class="h-23px w-23px rounded-sm"/>
                  </span>
                  <span class="navi-text">{{ item.name }}</span>
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <div class="uk-flex uk-flex-middle uk-flex-center" style="min-height: calc(95vh) !important; width: 100%">
      <div class="login-card d-flex uk-grid-collapse" uk-grid>
        <template v-if="!is_loading && company">
          <div v-if="hasLoginImage"
               class="uk-text-center uk-animation-scale-up p-0 uk-width-3-5@m d-flex left-side-image-2">
            <img :src="loginImageSrc" class="login-banner"/>
          </div>

          <div v-else class="uk-text-center uk-animation-scale-up p-0 uk-width-2-5@m login-bg left-side-image-1">
            <img :src="company.logo_link" alt="Company Logo" class="company-logo"/>
            <h3 class="mb-4">{{ company.name }}</h3>
            <p class="d-none">{{ company.type }}</p>
          </div>
        </template>

        <div class="uk-card-default p-5 uk-width-expand right-side-form ato-login-container">
          <div class="ato-login-wrapper">
            <button type="button" class="ato-login-button" @click="onAtoLogin">
              <img src="/media/images/atonet_logo_black.png" alt="ATONET" class="ato-login-icon"/>
              <span class="ato-login-text"> {{$t('general.login_with_ato')}} </span>
              <span class="ato-login-arrow">→</span>
            </button>
          </div>
        </div>
        <!--login form END-->
      </div>
    </div>
  </div>
</template>

<script>
import { GET_ITEM_DETAIL_BY_ID as COMPANY_DETAIL } from "@/core/services/store/REST.module";
import { SET_ERROR } from "@/core/services/store/auth.module";
import store from "@/core/services";
import SecureLS from "secure-ls";
import i18nService from "@/core/services/i18n.service.js";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });
import company_module, {
  MODULE_NAME as COMPANY_MODULE_NAME,
} from "@/core/services/store/company.module";
import { getAlias } from "@/utils/urlHelper";

export default {
  name: "AtoLogin",
  beforeCreate() {
    this.is_loading = true;

    const self = this;
    this.$store
        .dispatch(COMPANY_DETAIL, {
          url: "api/company/info",
          filters: { alias: getAlias() },
        })
        .then((result) => {
          this.is_loading = false;
          if (result.status) {
            const pureData = JSON.parse(JSON.stringify(result.data));
            if (Object.keys(pureData).length === 0) {
              this.$router.push({ path: "/404" });
            }

            self.company = result.data;
            if (!ls.get("language")) {
              i18nService.setActiveLanguage(
                  result.data?.language?.language
              );
              window.location.reload();
            }
          } else {
            this.$router.push({ path: "/404" });
          }
        })
        .catch((error) => {
          this.is_loading = false;
        });

    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(COMPANY_MODULE_NAME, company_module);
  },
  mounted() {
    this.subdomain = window.location.hostname;
    let url = window.location.href;
    if (url.includes("www.")) {
      this.company = {
        logo_link: "/media/images/anzera-logo-medium.png",
        name: "ATO",
        type: "Dijital Öğrenme Platformu",
        is_allowed_register_user: 0,
      };
    }

    this.$store.commit(SET_ERROR, "");
    let version = process.env.VUE_APP_VERSION;
    let localVersion = ls.get("version");
    if (!localVersion || version !== localVersion) {
      ls.set("version", version);
    }
  },
  data() {
    return {
      languages: i18nService.languages,
      languageFlag: "",
      subdomain: "",
      is_loading: true,
      company: {
        logo_link: "/media/images/anzera-logo-medium.png",
        name: "ATO",
        type: "Dijital Öğrenme Platformu",
        is_allowed_register_user: 0,
      },
    };
  },
  computed: {
    activeLanguage() {
      return i18nService.getActiveLanguage() ?? "tr";
    },
    hasLoginImage() {
      return !!this.loginImageSrc;
    },
    loginImageSrc() {
      const images = this.company?.login_images || {};
      if (!Object.keys(images).length) return "";

      return (
        images[this.activeLanguage] ||
        images.tr ||
        images.en ||
        images.az ||
        images.de ||
        Object.values(images).find(Boolean) ||
        ""
      );
    },
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
    loginLogoFooter() {
      return process.env.BASE_URL + "media/images/logo-dark.svg";
    },
  },
  methods: {
    selectedLanguage(e) {
      if (e) {
        const el = e.target.closest(".navi-link");
        const lang = el.getAttribute("data-lang");
        i18nService.setActiveLanguage(lang);
        this.$emit(
            "language-changed",
            this.languages.find((val) => {
              return val.lang === lang;
            })
        );
        window.location.reload();
      }
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    },
    onLanguageChanged() {
      this.languageFlag = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    onAtoLogin() {
      const atoLoginUrl = "https://giris.turkiye.gov.tr/OAuth2AuthorizationServer/AuthorizationController?response_type=code&client_id=32a6f77d-15b4-44d6-ab03-dff579d9e9eb&state=akademi&scope=Kimlik-Dogrula&redirect_uri=https://portal.atonet.org.tr/preview/67dbb266-9a08-407e-94f1-098211a42fa4/login.htm";
      window.location.href = atoLoginUrl;
    },
  },
};
</script>

<style scoped>
.navi-item:hover {
  background-color: #e8f0fe;
}

.right-side-form {
  width: 400px;
}

.ato-login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.left-side-image-1 {
  min-width: 400px;
}

.left-side-image-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 16px;
  min-width: 400px;
  max-width: 1000px;
}

.left-side-image-2 img {
  width: 100%;
  height: 100%;
}

.ato-login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.ato-login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 40px;
  background-color: #E8F0FE;
  border: 1px solid #1e3c72;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
  color: #1e3c72;
  width: 100%;
}

.ato-login-button:hover {
  background-color: #D0E3FF;
  border-color: #2a5298;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(30, 60, 114, 0.15);
  cursor: pointer;
}

.ato-login-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}

.ato-login-text {
  flex: 1;
  text-align: center;
  font-weight: 500;
  color: #1e3c72;
}

.ato-login-arrow {
  color: #1e3c72;
  font-size: 20px;
  font-weight: bold;
  flex-shrink: 0;
}
</style>
